import React from "react";

const ApplicationSummary = ({ data = [] }) => {
    return (
        <div className="bg-white rounded-lg shadow p-4 h-96 flex flex-col">
            <h2 className="text-xl font-bold text-gray-800 mb-4">
                Application Summary
            </h2>

            {/* Scrollable Table Container */}
            <div className="overflow-y-auto overflow-x-auto flex-1 border border-gray-200 rounded-lg">
                <table className="w-full">
                    <thead className="bg-[#1467B3] text-white sticky top-0 z-10">
                        <tr>
                            <th className="px-4 py-3 text-left font-semibold">
                                Application Name
                            </th>
                            <th className="px-4 py-3 text-left font-semibold">Count</th>
                            <th className="px-4 py-3 text-left font-semibold">Percentage</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((row, index) => (
                                <tr
                                    key={index}
                                    className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                                >
                                    <td className="px-4 py-3 text-gray-700">
                                        {row.Application_Name}
                                    </td>
                                    <td className="px-4 py-3 text-gray-900 font-semibold">
                                        {row.Count}
                                    </td>
                                    <td className="px-4 py-3 text-gray-700">
                                        {row.Percentage} %
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan="3"
                                    className="px-4 py-3 text-center text-gray-500"
                                >
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ApplicationSummary;
